<template>
    <v-card elevation="0" width="70%" style="margin: auto;">
        <br /><br /><br />
        <v-card-text style="height: 600px;">
            <v-row
                class="fill-height"
                justify="center" align="center"
            >
                <v-col cols="12" md="4" v-for="n in items" :key="n.title" class="d-flex align-center justify-center">
                    <v-card elevation="2" :color="n.color" :to="n.path" width="200" height="200">
                        <v-row justify="center" align="center" class="fill-height text-center">
                            <v-col cols="10">
                                <v-icon size="60px" color="white">{{ n.icon }}</v-icon><br />
                                <span style="color:white;" class="text-h6">{{ n.title }}</span>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>
<script>
export default {
    data(){
        return {
            items: [
                { 
                    title: "Settings", 
                    icon: "mdi-cog-outline", 
                    path: "/config",
                    color: "#8FABB3"
                },
                { 
                    title: "Announcements", 
                    icon: "mdi-bullhorn-outline", 
                    path: "/announcements",
                    color: "#D4C88D"
                },
                { 
                    title: "Net Bill", 
                    icon: "mdi-file-table-outline", 
                    path: "/netbilladmin",
                    color: "#8FB3A3"
                },
                { 
                    title: "T2202A", 
                    icon: "mdi-file-edit-outline", 
                    path: "/t2202aadmin",
                    color: "#98B38F"
                },
                { 
                    title: "Student Data", 
                    icon: "mdi-account-search-outline", 
                    path: "/studentdata",
                    color: "#BE977E"
                }
            ]
        }
    },
    methods: {
    }
}
</script>